import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { LiveTracker } from '../components/LiveTracker';

export const PlayerAwardsLiveTrackerProvider = ({ store, data }) => (
    <Provider store={store}>
        <LiveTracker {...data} />
    </Provider>
);

PlayerAwardsLiveTrackerProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
